import { render, staticRenderFns } from "./FamilyFriendPricing.vue?vue&type=template&id=df726264&"
import script from "./FamilyFriendPricing.vue?vue&type=script&lang=js&"
export * from "./FamilyFriendPricing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports